<template>
  <div class="nutrition-page">
    <UserAppChrome />

    <main class="nutrition-shell">
      <UserSectionHeader
        eyebrow="Il tuo piano"
        title="Le tue alimentazioni"
        description="Consulta i piani personalizzati preparati dal Team Nutrizionale e gestisci ogni passaggio del tuo percorso."
      />

      <!-- Div per la registrazione e inserimento dati -->
      <div v-if="!isLoadingComponent && mostraDivRegistrazione" class="grid-item special-container">
        <h3>STEP 1</h3>
        <p>
          Aspetta di ricevere l'approvazione per la videocall con il Team Nutrizionale. Dopo l'approvazione, avrai la libertà di selezionare l'orario che più preferisci, sempre in questa pagina.
        </p>
        <p>Inserisci il tuo <strong>Codice fiscale e il Luogo di Nascita</strong>, così da avere i dati per continuare ed approvare.</p>
        <input v-model="codFiscale" placeholder="Codice Fiscale" class="codfiscale-input"/>
        <input v-model="luogoNascita" placeholder="Luogo di Nascita" class="luogonascita-input"/>


        <p>
Leggi ed accetta la nostra lettera di incarico, informativa e consenso sul trattamento dei dati personali per la consulenza a distanza</p>



        <!-- Accordion per la privacy -->
        <div>
          <button @click="togglePrivacy" class="accordion-btn">
            Leggi la lettera di incarico e privacy
          </button>
          <div v-if="mostraPrivacy" class="privacy-content">
            <p>
              Con la sottoscrizione della presente scrittura dichiara:
              <br><br>
              1. Di voler affidare alle Dott.sse Francesca De Propris/ Erica Profeta/ Celestina Asomba/ Martina Ferraro/ Francesca Di Giovanni, iscritte all’Albo Professionale dei Biologi, Sezione A, l'incarico professionale per la valutazione dei propri bisogni nutritivi ed energetici, ai sensi dell'art. 3 della legge n. 396/1967, e coerentemente per l’elaborazione di una dieta ottimale personalizzata.
              <br><br>
              Il presente incarico decorre dalla sottoscrizione del presente documento e si intende conferito fino alla conclusione della prestazione professionale richiesta.
              <br><br>
              Alla figura del Biologo nutrizionista è riconosciuta dalla legge la competenza di elaborare, in maniera autonoma, profili nutrizionali sia nei confronti di soggetti sani, sia di soggetti a cui è stata diagnosticata una patologia, per il miglioramento del benessere e della salute.
            </p>
            <p>
              Leggi nel dettaglio la <a href="https://www.metodofusco.it/media/LETTERA%20DI%20INCARICO%20e%20PRIVACY.pdf" target="_blank">Lettera di incarico e privacy</a>.
            </p>
          </div>

          <!-- Checkbox per accettare la privacy, messo inline con il testo -->
          <div class="privacy-checkbox">
            <input type="checkbox" v-model="privacyAccettata" id="privacyAccettata" />
            <label for="privacyAccettata">Ho letto e accetto la privacy Policy</label>
          </div>
        </div>

        <div v-if="datiSalvati" class="dati-salvati">Dati salvati con successo, attendi l'approvazione.</div>

        <!-- Bottone per salvare -->
        <button @click="salvaDatiUtente" class="save-btn">Salva</button>
        <div class="loading-text">APPROVAZIONE IN CORSO<span class="dots">...</span></div>
      </div>


      <section class="nutrition-list" aria-label="Piani alimentari">
        <article
          v-for="(data, index) in alimentazione"
          :key="index"
          class="nutrition-card"
          :class="{ 'nutrition-card--open': currentAccordion === index }"
        >
          <button
            type="button"
            class="nutrition-card__trigger"
            :aria-expanded="currentAccordion === index"
            @click="toggleAccordion(index)"
          >
            <span class="nutrition-card__number">{{ String(index + 1).padStart(2, '0') }}</span>
            <span class="nutrition-card__copy">
              <small>Piano alimentare</small>
              <strong>{{ formatDate(data.dataCreazione) }}</strong>
            </span>
            <span class="material-icons nutrition-card__chevron" aria-hidden="true">
              {{ currentAccordion === index ? 'remove' : 'add' }}
            </span>
          </button>


        <div v-if="currentAccordion === index" class="order-details">
  <div class="grid-container23">
    <!-- Testo e bottone per la video call, unificati in un unico blocco -->
    <div v-if="data.videocall === 'SI'" class="grid-item">
      <p>Prenota la video call con la nostra nutrizionista, puoi scegliere uno slot, se non trovi orari disponibili o hai commesso un errore, contattaci.</p>
      <button @click="goToBooking">Prenota la video call</button>
    </div>



    <div class="grid-item">
  <!-- Messaggio e bottone per il link Dropbox 
  <p v-if="data.linkAlimentazione">
    <strong>Clicca qui sotto per leggere la tua alimentazione tramite Dropbox.</strong>
  </p>
  <button v-if="data.linkAlimentazione" @click="openLink(data.linkAlimentazione)">
    Leggi la tua alimentazione (Dropbox)
  </button>-->

  <p class="read-only-text">{{ data.nota2 || 'Nessuna nota aggiuntiva' }}</p>

  <p>
    <strong>Clicca qui sotto per visualizzare il file PDF della tua alimentazione, altrimenti utilizza il bottone per ricevere il link diretto al pdf per email.</strong>
  </p>


  <!-- Controllo per i PDF -->
  <p v-if="data.fileType === 'pdf' && data.fileUrl">
      <strong>Il tuo PDF:</strong>
    </p>

    <!-- Visualizzatore PDF -->
    <iframe
      v-if="data.fileType === 'pdf' && data.fileUrl"
      :src="getPdfViewerUrl(data.fileUrl)"
      width="100%"
      height="500px"
      class="pdf-viewer"
    ></iframe>

    <!-- Nuovo bottone per aprire il PDF in una nuova finestra -->
<button
  v-if="data.fileType === 'pdf' && data.fileUrl"
  @click="openLink(data.fileUrl)"
  class="open-pdf-btn"
>
  Apri PDF in nuova finestra
</button>

    <!-- Messaggio se non c'è un file disponibile -->
    <p v-if="!data.fileUrl">
      Nessun file disponibile al momento. Attendi il caricamento della tua alimentazione.
    </p>


    <div class="grid-item">
  <!-- Bottone per inviare l'email -->
  <button 
  v-if="!alimentazione[index]?.isSendingEmail" 
  @click="triggerEmail(index)" 
  :disabled="data.fileUrl === null"  
  class="send-email-btn">
  {{ data.fileUrl ? 'Ricevi l\'alimentazione in formato pdf per email' : 'Il nostro team sta elaborando il tuo piano.' }}
</button>

<p v-if="alimentazione[index]?.isSendingEmail" class="loading-message">
  Invio in corso...
</p>

</div>




</div>

    <div v-if="hasVisibleIntegration(data)" class="grid-item integrazione-section">
      <header class="integrazione-heading">
        <div>
          <span class="integrazione-eyebrow">Selezione del Team Nutrizionale</span>
          <h2>Integrazione consigliata</h2>
          <p>Una selezione mirata per accompagnare il tuo piano alimentare.</p>
        </div>
      </header>

      <template v-if="getCustomerVitastrongBundles(data).length">
        <div class="integrazione-partner-row">
          <span class="integrazione-partner">Vitastrong</span>
          <span class="integrazione-selection-status">
            <span class="material-icons" aria-hidden="true">verified</span>
            {{ getCustomerVitastrongBundles(data).length === 1 ? '1 bundle selezionato' : `${getCustomerVitastrongBundles(data).length} bundle selezionati` }}
          </span>
        </div>
        <div class="integrazione-bundles">
          <article
            v-for="(bundle, bundleIndex) in getCustomerVitastrongBundles(data)"
            :key="bundle.bundleId"
            class="integrazione-bundle-card"
          >
            <header class="integrazione-bundle-head">
              <span class="integrazione-bundle-index">{{ String(bundleIndex + 1).padStart(2, '0') }}</span>
              <div>
                <span class="integrazione-bundle-kicker">Bundle consigliato</span>
                <h3 class="integrazione-bundle-title">{{ bundle.title }}</h3>
              </div>
            </header>

            <div class="integrazione-bundle-content">
              <div class="integrazione-products">
                <p class="integrazione-products-label">
                  <span class="material-icons" aria-hidden="true">inventory_2</span>
                  Prodotti inclusi
                </p>
                <ul class="integrazione-list">
                  <li
                    v-for="product in bundle.products"
                    :key="product"
                    class="integrazione-item"
                  >
                    <span class="material-icons" aria-hidden="true">check</span>
                    <span>{{ product }}</span>
                  </li>
                </ul>
              </div>

              <div class="integrazione-price">
                <span>Prezzo bundle</span>
                <strong>{{ formatIntegrationPrice(bundle.priceCents, bundle.currency) }}</strong>
              </div>
            </div>

            <button
              type="button"
              class="integrazione-button integrazione-button--vitastrong"
              :aria-label="`Acquista ${bundle.title} su Vitastrong`"
              @click="openLink(bundle.purchaseUrl)"
            >
              <span>
                <small>Acquista su Vitastrong</small>
                <strong>{{ bundle.title }}</strong>
              </span>
              <span class="material-icons" aria-hidden="true">north_east</span>
            </button>
          </article>
        </div>
        <div class="integrazione-shop-note">
          <span class="material-icons" aria-hidden="true">info</span>
          <p>Il pulsante apre il carrello dedicato. Prezzo e disponibilità finali vengono confermati su Vitastrong.</p>
        </div>
      </template>

      <template v-else-if="hasLegacyIntegration(data)">
        <div class="integrazione-partner-row">
          <span class="integrazione-partner integrazione-partner--legacy">Yamamoto · storico</span>
        </div>
        <h3 class="integrazione-title">Integrazione assegnata</h3>
        <p class="integrazione-note">
          Questa è l'integrazione storica associata alla tua alimentazione.
        </p>
        <ul class="integrazione-list integrazione-list--legacy">
          <li
            v-for="(label, labelIndex) in getLegacyIntegrationLabels(data)"
            :key="`${label}-${labelIndex}`"
            class="integrazione-item"
          >
            {{ label }}
          </li>
        </ul>
        <button
          v-if="hasLegacyProductSelection(data)"
          type="button"
          class="integrazione-button integrazione-button--legacy"
          @click="openTrackedYamamotoLink()"
        >
          Acquista integrazione Yamamoto x Fusco Fit
        </button>
      </template>

      <div class="integrazione-disclaimer">
        <span class="material-icons" aria-hidden="true">medical_information</span>
        <p>
          L'integrazione è facoltativa e a scopo generico; in caso di patologie o terapie farmacologiche in corso
          è obbligatorio consultare il medico prima dell'assunzione.
        </p>
      </div>
    </div>





  </div>
        </div>
        </article>
      </section>

      <aside class="nutrition-support">
        <div class="nutrition-support__copy">
          <span class="material-icons" aria-hidden="true">support_agent</span>
          <div>
            <small>Supporto dedicato</small>
            <h2>Hai bisogno del Team Nutrizionale?</h2>
            <p>Apri una richiesta e raccontaci come possiamo aiutarti.</p>
          </div>
        </div>
        <a href="/tickets/#/create-ticket" class="ticket-button">
          Apri un ticket
          <span class="material-icons" aria-hidden="true">north_east</span>
        </a>
      </aside>
    </main>
  </div>
</template>

<script>
import { getFunctions, httpsCallable } from 'firebase/functions';
import { useRouter } from 'vue-router';
import { ref, computed, onMounted } from 'vue';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';
import { getTrackExternalYamamotoAppUrl } from '@/lib/env';
import {
  formatIntegrationPrice,
  getLegacyIntegrationLabels,
  getVitastrongBundles,
  hasLegacyIntegration,
} from '@/lib/integrazione';
import { saveProtectedAlimentazioni } from '@/lib/integrazioneStore';
import UserAppChrome from './UserAppChrome.vue';
import UserSectionHeader from './UserSectionHeader.vue';

export default {
  components: { UserAppChrome, UserSectionHeader },
  setup() {
    const datiSalvati = ref(false);
    const privacyAccettata = ref(false);
    const mostraPrivacy = ref(false);
    const showPrivacyError = ref(false);
    const router = useRouter();
    const alimentazione = ref([]);
    const userId = ref(null);
    const currentAccordion = ref(null);
    const auth = getAuth();
    const codFiscale = ref('');
    const luogoNascita = ref('');
    const isLoadingComponent = ref(true); // Per il caricamento iniziale
    const isLoadingEmail = ref(false);    // Per il caricamento dell'email
    const yamamotoIntegrationUrl = 'https://www.yamamotonutrition.com/it_it/yamamoto-x-fusco-fit';
    const trackExternalLinkUrl = getTrackExternalYamamotoAppUrl();

    const getCustomerVitastrongBundles = (item) => (
      hasLegacyIntegration(item) ? [] : getVitastrongBundles(item)
    );

    const hasVisibleIntegration = (item) => (
      getCustomerVitastrongBundles(item).length > 0 || hasLegacyIntegration(item)
    );

    const hasLegacyProductSelection = (item) => (
      hasLegacyIntegration(item) &&
      Array.isArray(item?.integrazioneProducts) &&
      item.integrazioneProducts.length > 0
    );


const verificaDatiSalvati = async () => {
  if (!userId.value) {
    isLoadingComponent.value = false;
    return;
  }

  const db = getFirestore();
  try {
    const userDocRef = doc(db, 'users', userId.value);
    const userDocSnap = await getDoc(userDocRef);

    if (userDocSnap.exists()) {
      const userData = userDocSnap.data();
      
      codFiscale.value = userData.codFiscale || '';
      luogoNascita.value = userData.luogoNascita || '';

      if (codFiscale.value && luogoNascita.value) {
        datiSalvati.value = true;
      }
    }
  } catch (error) {
    console.error('Errore durante il recupero dei dati utente:', error);
  } finally {
    isLoadingComponent.value = false;
  }
};



const triggerEmail = async (alimentazioneIndex) => {
  try {
    if (!userId.value) {
      throw new Error("Utente non autenticato");
    }
    const localEntry = alimentazione.value[alimentazioneIndex];
    if (!localEntry?.id) {
      throw new Error("Alimentazione senza identificativo. Ricarica la pagina.");
    }
    const db = getFirestore();
    const requestAt = Date.now();

    // Imposta il loader temporaneo locale
    if (alimentazione.value[alimentazioneIndex]) {
      alimentazione.value[alimentazioneIndex].isSendingEmail = true;
    }

    // Recupera la lista di alimentazioni dal database
    const alimentazioniRef = doc(db, "alimentazioni", userId.value);
    const alimentazioniSnap = await getDoc(alimentazioniRef);
    const baseEntries = alimentazioniSnap.exists()
      ? alimentazioniSnap.data().alimentazioni || []
      : [];
    const persistedIndex = baseEntries.findIndex((item) => item?.id === localEntry.id);

    // Imposta il campo `invioEmail` su `true` per l'alimentazione selezionata
    if (persistedIndex >= 0) {
      const baseEntry = baseEntries[persistedIndex];
      const updatedEntry = {
        ...baseEntry,
        invioEmail: true,
        emailRequestAt: requestAt,
      };

      await saveProtectedAlimentazioni({
        userId: userId.value,
        entries: [updatedEntry],
        baseEntries: [baseEntry],
      });
    } else {
      throw new Error("Alimentazione non trovata");
    }

    // Aggiorna lo stato locale per mostrare il messaggio
    if (alimentazione.value[alimentazioneIndex]) {
      alimentazione.value[alimentazioneIndex].invioEmail = true;
      alimentazione.value[alimentazioneIndex].emailRequestAt = requestAt;
    }
    console.log("Richiesta invio email registrata.");

    setTimeout(() => {
      if (alimentazione.value[alimentazioneIndex]) {
        alimentazione.value[alimentazioneIndex].isSendingEmail = false;
      }
    }, 3000);
  } catch (error) {
    console.error("Errore nel trigger email:", error);
    if (alimentazione.value[alimentazioneIndex]) {
      alimentazione.value[alimentazioneIndex].isSendingEmail = false;
    }
    alert("Errore durante l'invio dell'email. Riprova più tardi.");
  }
};







    const sendPdfEmail = async (fileUrl) => {
      const functions = getFunctions(); // Assicurati che sia importato
      const sendEmailFunction = httpsCallable(functions, 'sendPdfEmail');

      try {
        isLoadingEmail.value = true;
        const userId = 'user-id-test'; // Sostituisci con l'ID dell'utente autenticato
        if (!userId) {
          alert('Utente non autenticato. Effettua il login per procedere.');
          isLoadingEmail.value = false;
          return;
        }

        const response = await sendEmailFunction({ userId, fileUrl });
        alert(response.data.message || 'Email inviata con successo!');
      } catch (error) {
        console.error('Errore durante l\'invio dell\'email:', error);
        alert('Errore durante l\'invio dell\'email. Riprova più tardi.');
      } finally {
        isLoadingEmail.value = false;
      }
    };


const getPdfViewerUrl = (pdfUrl) => {
      return `https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(pdfUrl)}`;
    };



    const openWithGoogleDrive = (pdfUrl) => {
    const googleDriveViewer = `https://drive.google.com/viewerng/viewer?embedded=true&url=${encodeURIComponent(pdfUrl)}`;
    window.open(googleDriveViewer, '_blank');
  };


    const buildTrackedYamamotoIntegrationLink = (source = 'app') => {
      if (!trackExternalLinkUrl) return yamamotoIntegrationUrl;
      const params = new URLSearchParams();
      params.set('s', source || 'app');
      params.set('c', 'alimentazione-integrazione');
      params.set('ctx', 'alimentazione-page');
      if (userId.value) {
        params.set('u', userId.value);
      }
      return `${trackExternalLinkUrl}?${params.toString()}`;
    };

    const openTrackedYamamotoLink = () => {
      openLink(buildTrackedYamamotoIntegrationLink('app'));
    };

    const getTrackedYamamotoShareUrl = (source = 'share') => {
      return buildTrackedYamamotoIntegrationLink(source || 'whatsapp_email');
    };


    const openLink = (url) => {
  if (url && url !== '#') {
    isLoadingEmail.value = true;

    // Apri il link nel browser di sistema
    if (window.ReactNativeWebView) {
      // Caso specifico per WebView (React Native o simili)
      window.ReactNativeWebView.postMessage(JSON.stringify({ action: 'openLink', url }));
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }

    // Nascondi il loader dopo 5 secondi
    setTimeout(() => {
      isLoadingEmail.value = false;
    }, 5000);
  } else {
    alert('Il link non è valido o non è stato ancora generato.');
  }
};



    // Funzione per alternare la visibilità della privacy
    const togglePrivacy = () => {
      mostraPrivacy.value = !mostraPrivacy.value;
    };

    const salvaDatiUtente = async () => {
  if (!userId.value || !codFiscale.value || !luogoNascita.value || !privacyAccettata.value) {
    if (!privacyAccettata.value) {
      showPrivacyError.value = true;
      setTimeout(() => (showPrivacyError.value = false), 5000);
    }
    alert('Per favore, compila tutti i campi e accetta la privacy.');
    return;
  }

  const db = getFirestore();
  try {
    // Aggiungiamo la data corrente per tracciare quando la privacy viene accettata
    const dataPrivacyAccettata = privacyAccettata.value ? new Date().toISOString() : null;

    // Salvataggio dei dati nel database
    await setDoc(
      doc(db, 'users', userId.value),
      {
        codFiscale: codFiscale.value,
        luogoNascita: luogoNascita.value,
        privacyAccettata: privacyAccettata.value,
        dataPrivacyAccettata: dataPrivacyAccettata, // Salviamo la data di accettazione della privacy
      },
      { merge: true }
    );

    datiSalvati.value = true; // Imposta datiSalvati a true dopo il salvataggio corretto
    alert('Dati salvati con successo!');
  } catch (error) {
    console.error('Errore nel salvare i dati: ', error);
    alert('Errore nel salvare i dati.');
  }
};



    const isWithin7Days = (timestamp) => {
      const now = new Date();
      const selectionDate = timestamp.toDate();
      const diffTime = Math.abs(now - selectionDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays <= 7;
    };


    onAuthStateChanged(auth, (user) => {
      if (user) {
        userId.value = user.uid;
        fetchAlimentazione();
      }
    });

    const mostraDivRegistrazione = computed(() => {
  return !(codFiscale.value && luogoNascita.value && datiSalvati.value);
});




    const goToBooking = () => {
      router.push('/booking');
    };

    const toggleAccordion = (index) => {
      if (currentAccordion.value === index) {
        currentAccordion.value = null;
      } else {
        currentAccordion.value = index;
      }
    };

    const formatDate = (timestamp) => {
      if (!timestamp) {
        return '';
      }
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp.seconds * 1000);
      return date.toLocaleDateString('it-IT');
    };



    const fetchAlimentazione = async () => {
  if (!userId.value) {
    console.error("Utente non autenticato");
    return;
  }

  const db = getFirestore();

  try {
    // Recupero dati utente da 'users'
    const userDocRef = doc(db, "users", userId.value);
    const userDocSnap = await getDoc(userDocRef);

    if (userDocSnap.exists()) {
      const userData = userDocSnap.data();
      codFiscale.value = userData.codFiscale || '';
      luogoNascita.value = userData.luogoNascita || '';
      privacyAccettata.value = userData.privacyAccettata || false;
    } else {
      console.log("Nessun dato utente trovato");
    }

    // Recupero dati di alimentazione da 'alimentazioni'
    const alimentazioneDocRef = doc(db, "alimentazioni", userId.value);
    const alimentazioneDocSnap = await getDoc(alimentazioneDocRef);

    if (alimentazioneDocSnap.exists()) {
      alimentazione.value = alimentazioneDocSnap.data().alimentazioni.map(item => ({
        ...item,
        canBook: item.dataSelezioneSI ? isWithin7Days(item.dataSelezioneSI) : false, // Manteniamo questa logica
        fileType: item.fileType || null, // Recupero del tipo di file
        fileUrl: item.fileUrl || null, // Recupero del link al file
      }));
    } else {
      console.log("Nessun dato di alimentazione trovato per questo utente");
    }
  } catch (error) {
    console.error("Errore durante il recupero dei dati di alimentazione:", error);
  }
};








onMounted(() => {
  if (auth.currentUser) {
    userId.value = auth.currentUser.uid;
    verificaDatiSalvati(); // Controlla se i dati sono già salvati
    fetchAlimentazione();  // Recupera le alimentazioni
  }
});


    return {
      alimentazione,
      formatDate,
      currentAccordion,
      toggleAccordion,
      userId,
      mostraDivRegistrazione,
      goToBooking,
      codFiscale,
      luogoNascita,
      salvaDatiUtente,
      datiSalvati,
      privacyAccettata,
      mostraPrivacy,
      togglePrivacy,
      formatIntegrationPrice,
      getLegacyIntegrationLabels,
      getCustomerVitastrongBundles,
      hasLegacyIntegration,
      hasLegacyProductSelection,
      hasVisibleIntegration,
      openLink,
      openTrackedYamamotoLink,
      getTrackedYamamotoShareUrl,
      openWithGoogleDrive,
      getPdfViewerUrl,
      sendPdfEmail,
      triggerEmail,
      isLoadingComponent,
      isLoadingEmail,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=Montserrat:ital,wght@0,700;0,900;1,900&display=swap');

.nutrition-page {
  --ff-bg: #f5f4f0;
  --ff-surface: rgba(255, 255, 255, 0.72);
  --ff-white: #ffffff;
  --ff-black: #111110;
  --ff-muted: #5f5e5a;
  --ff-line: rgba(17, 17, 16, 0.1);
  --ff-red: #d50b35;
  --ff-red-dark: #a80727;
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  color: var(--ff-black);
  background:
    radial-gradient(circle at 94% 7%, rgba(213, 11, 53, 0.1), transparent 23rem),
    radial-gradient(circle at 4% 72%, rgba(213, 11, 53, 0.055), transparent 25rem),
    var(--ff-bg);
  font-family: 'DM Sans', sans-serif;
}

.nutrition-page::before {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  content: '';
  opacity: 0.25;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 180 180' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='.08'/%3E%3C/svg%3E");
}

.nutrition-shell {
  position: relative;
  z-index: 1;
  width: min(100%, 980px);
  min-height: calc(100vh - 60px);
  margin: 0 auto;
  padding: clamp(34px, 6vw, 72px) clamp(20px, 5vw, 52px) 148px;
  box-sizing: border-box;
}

.nutrition-list {
  display: grid;
  gap: 13px;
}

.nutrition-card {
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 22px;
  background: var(--ff-surface);
  box-shadow:
    0 18px 45px rgba(47, 38, 32, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(18px) saturate(135%);
  -webkit-backdrop-filter: blur(18px) saturate(135%);
  transition: transform 220ms ease, box-shadow 220ms ease, border-color 220ms ease;
}

.nutrition-card::before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 4px;
  content: '';
  background: var(--ff-red);
  transform: scaleY(0);
  transform-origin: bottom;
  transition: transform 220ms ease;
}

.nutrition-card:hover,
.nutrition-card--open {
  border-color: rgba(213, 11, 53, 0.17);
  box-shadow:
    0 22px 55px rgba(47, 38, 32, 0.11),
    inset 0 1px 0 rgba(255, 255, 255, 0.95);
}

.nutrition-card:hover {
  transform: translateY(-2px);
}

.nutrition-card--open::before {
  transform: scaleY(1);
}

.nutrition-card__trigger {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr) 42px;
  gap: 17px;
  align-items: center;
  width: 100%;
  min-height: 94px;
  margin: 0;
  padding: 15px 18px;
  color: var(--ff-black);
  text-align: left;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.nutrition-card__number {
  display: grid;
  width: 54px;
  height: 54px;
  place-items: center;
  color: var(--ff-red);
  border: 1px solid rgba(213, 11, 53, 0.14);
  border-radius: 17px;
  background: rgba(213, 11, 53, 0.075);
  font-family: 'Montserrat', sans-serif;
  font-size: 0.78rem;
  font-weight: 900;
  letter-spacing: 0.08em;
}

.nutrition-card__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.nutrition-card__copy small {
  color: #807e79;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
}

.nutrition-card__copy strong {
  overflow: hidden;
  font-size: clamp(1rem, 2.8vw, 1.22rem);
  font-weight: 700;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nutrition-card__chevron {
  display: grid;
  width: 40px;
  height: 40px;
  place-items: center;
  color: var(--ff-white);
  border-radius: 50%;
  background: var(--ff-black);
  font-size: 1.35rem;
  transition: transform 220ms ease, background 220ms ease;
}

.nutrition-card--open .nutrition-card__chevron {
  background: var(--ff-red);
  transform: rotate(180deg);
}

.nutrition-card__trigger:focus-visible,
.ticket-button:focus-visible,
.order-details button:focus-visible,
.accordion-btn:focus-visible,
.save-btn:focus-visible {
  outline: 3px solid rgba(213, 11, 53, 0.32);
  outline-offset: 3px;
}

.order-details {
  display: block;
  position: relative;
  margin: 0;
  padding: 0 clamp(18px, 4vw, 32px) clamp(22px, 4vw, 34px);
  color: var(--ff-black);
  border-top: 1px solid var(--ff-line);
  border-radius: 0;
  background: rgba(255, 255, 255, 0.28);
  animation: reveal-details 240ms ease both;
}

@keyframes reveal-details {
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
}

.grid-container23 {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin: 0;
  padding-top: 24px;
}

.grid-item {
  min-height: 0;
  margin: 0;
}

.order-details p {
  margin: 0 0 16px;
  color: var(--ff-muted);
  font-size: 0.96rem;
  line-height: 1.58;
}

.order-details p strong {
  color: var(--ff-black);
}

.read-only-text {
  padding: 17px 18px;
  color: var(--ff-black) !important;
  border-left: 3px solid var(--ff-red);
  border-radius: 0 14px 14px 0;
  background: rgba(213, 11, 53, 0.055);
}

.order-details button,
.accordion-btn,
.save-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-height: 48px;
  margin: 4px 0 0;
  padding: 12px 20px;
  color: var(--ff-white);
  border: 0;
  border-radius: 999px;
  background: var(--ff-red);
  font-family: 'DM Sans', sans-serif;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 180ms ease, background 180ms ease, opacity 180ms ease;
}

.order-details button:hover,
.accordion-btn:hover,
.save-btn:hover {
  background: var(--ff-red-dark);
  transform: translateY(-1px);
}

.order-details button:disabled {
  color: #77736d;
  background: #dfddd8;
  cursor: not-allowed;
  transform: none;
}

.send-email-btn,
.open-pdf-btn {
  width: 100% !important;
  text-align: center;
}

.pdf-viewer {
  display: block;
  min-height: 500px;
  border: 1px solid var(--ff-line);
  border-radius: 16px;
  background: var(--ff-white);
}

.loading-message,
.email-message {
  color: var(--ff-red) !important;
  font-weight: 700;
}

.special-container {
  margin: 0 0 20px;
  padding: clamp(22px, 4vw, 34px);
  color: var(--ff-black);
  border: 1px solid rgba(213, 11, 53, 0.2);
  border-radius: 22px;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.88), rgba(255, 255, 255, 0.6)),
    rgba(213, 11, 53, 0.04);
  box-shadow: 0 18px 45px rgba(47, 38, 32, 0.08);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.special-container h3 {
  margin: 0 0 12px;
  color: var(--ff-red);
  font-family: 'Montserrat', sans-serif;
  font-size: 0.75rem;
  font-weight: 900;
  letter-spacing: 0.14em;
}

.special-container p {
  color: var(--ff-muted);
  line-height: 1.55;
}

.special-container p strong {
  color: var(--ff-black);
}

.codfiscale-input,
.luogonascita-input {
  display: block;
  width: 100%;
  min-height: 52px;
  margin: 10px 0;
  padding: 12px 16px;
  box-sizing: border-box;
  color: var(--ff-black);
  border: 1px solid rgba(17, 17, 16, 0.14);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.76);
  font: inherit;
  font-size: 1rem;
  outline: none;
}

.codfiscale-input:focus,
.luogonascita-input:focus {
  border-color: var(--ff-red);
  box-shadow: 0 0 0 3px rgba(213, 11, 53, 0.1);
}

.accordion-btn,
.save-btn {
  width: 100%;
}

.privacy-content {
  max-height: 320px;
  overflow-y: auto;
  margin: 12px 0;
  padding: 18px;
  border: 1px solid var(--ff-line);
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.72);
}

.privacy-content a {
  color: var(--ff-red);
  font-weight: 700;
}

.privacy-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 15px 0;
  color: var(--ff-muted);
}

.privacy-checkbox input {
  width: 19px;
  height: 19px;
  margin: 0;
  accent-color: var(--ff-red);
}

.dati-salvati {
  margin: 12px 0;
  color: #287a45;
  font-weight: 700;
}

.loading-text {
  margin-top: 16px;
  color: #77736d;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.dots {
  display: inline-block;
  margin-left: 5px;
}

.dots::after {
  content: '|';
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 100% { opacity: 0; }
  50% { opacity: 1; }
}

.integrazione-section {
  position: relative;
  overflow: hidden;
  margin-top: 6px;
  padding: clamp(20px, 4vw, 30px);
  color: var(--ff-black);
  border: 1px solid rgba(17, 17, 16, 0.08);
  border-radius: 24px;
  background:
    radial-gradient(circle at 100% 0, rgba(213, 11, 53, 0.1), transparent 18rem),
    rgba(255, 255, 255, 0.82);
  box-shadow: 0 18px 50px rgba(38, 31, 28, 0.08);
}

.integrazione-section::before {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 4px;
  content: '';
  background: linear-gradient(90deg, var(--ff-red), #ff5275 48%, rgba(213, 11, 53, 0.08));
}

.integrazione-heading {
  width: 100%;
  text-align: center;
}

.integrazione-eyebrow {
  display: block;
  margin: 1px 0 5px;
  color: var(--ff-red-dark);
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.integrazione-heading h2 {
  margin: 0;
  color: var(--ff-black);
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(1.35rem, 4vw, 1.8rem);
  font-weight: 900;
  line-height: 1.05;
  text-align: center;
}

.integrazione-heading p {
  margin: 8px 0 0;
  color: var(--ff-muted);
  font-size: 0.88rem;
  line-height: 1.45;
  text-align: center;
}

.integrazione-partner-row {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  margin: 24px 0 12px;
}

.integrazione-partner {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 11px;
  color: var(--ff-red-dark);
  border: 1px solid rgba(213, 11, 53, 0.12);
  border-radius: 999px;
  background: rgba(213, 11, 53, 0.075);
  font-size: 0.64rem;
  font-weight: 900;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.integrazione-selection-status {
  display: inline-flex;
  gap: 6px;
  align-items: center;
  color: #65625e;
  font-size: 0.72rem;
  font-weight: 700;
}

.integrazione-selection-status .material-icons {
  color: var(--ff-red);
  font-size: 1rem;
}

.integrazione-partner--legacy {
  color: #6b5315;
  background: #fff1be;
}

.integrazione-title {
  margin: 16px 0 7px;
  color: var(--ff-black);
  font-size: 1.3rem;
  font-weight: 800;
}

.integrazione-note,
.integrazione-shop-note,
.integrazione-disclaimer {
  color: var(--ff-muted) !important;
}

.integrazione-bundles {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 310px), 1fr));
  gap: 14px;
}

.integrazione-bundle-card {
  display: flex;
  min-width: 0;
  min-height: 330px;
  flex-direction: column;
  padding: clamp(18px, 3vw, 24px);
  color: var(--ff-white);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 21px;
  background:
    radial-gradient(circle at 100% 0, rgba(213, 11, 53, 0.48), transparent 13rem),
    linear-gradient(145deg, #181817, #282421);
  box-shadow: 0 18px 38px rgba(17, 17, 16, 0.18);
}

.integrazione-bundle-head {
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr);
  gap: 13px;
  align-items: center;
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.integrazione-bundle-index {
  display: grid;
  width: 46px;
  height: 46px;
  place-items: center;
  color: var(--ff-white);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);
  font-family: 'Montserrat', sans-serif;
  font-size: 0.72rem;
  font-weight: 900;
}

.integrazione-bundle-kicker {
  display: block;
  margin-bottom: 3px;
  color: rgba(255, 255, 255, 0.58);
  font-size: 0.61rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.integrazione-bundle-title {
  margin: 0;
  color: var(--ff-white);
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(1rem, 2.7vw, 1.25rem);
  font-weight: 900;
  line-height: 1.12;
}

.integrazione-bundle-content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 18px;
  align-items: end;
  flex: 1;
  padding: 20px 0;
}

.integrazione-products-label {
  display: flex;
  gap: 7px;
  align-items: center;
  margin: 0 0 10px !important;
  color: rgba(255, 255, 255, 0.58) !important;
  font-size: 0.64rem !important;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.integrazione-products-label .material-icons {
  color: var(--ff-white) !important;
  font-size: 1rem;
}

.integrazione-bundle-card .integrazione-list {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.integrazione-bundle-card .integrazione-item {
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr);
  gap: 8px;
  align-items: center;
  margin: 0;
  padding: 0;
  color: var(--ff-white);
  border: 0;
  background: transparent;
  font-size: 0.86rem;
  font-weight: 600;
  line-height: 1.35;
}

.integrazione-bundle-card .integrazione-item .material-icons {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  color: var(--ff-white);
  border-radius: 50%;
  background: var(--ff-red);
  font-size: 0.82rem;
}

.integrazione-list--legacy {
  margin: 0 0 16px 19px;
  padding: 0;
  color: var(--ff-black);
}

.integrazione-list--legacy .integrazione-item {
  margin: 7px 0;
  color: var(--ff-black);
  font-size: 0.9rem;
  font-weight: 650;
  line-height: 1.45;
}

.integrazione-list--legacy .integrazione-item::marker {
  color: var(--ff-red);
}

.integrazione-price {
  min-width: 94px;
  margin: 0 !important;
  padding: 12px;
  color: var(--ff-white) !important;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.07);
}

.integrazione-price span {
  display: block;
  margin-bottom: 4px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.integrazione-price strong {
  display: block;
  color: var(--ff-white);
  font-family: 'Montserrat', sans-serif;
  font-size: 1.15rem;
  font-weight: 900;
  white-space: nowrap;
}

.integrazione-section .integrazione-button--vitastrong {
  display: flex;
  width: 100%;
  min-height: 58px;
  gap: 14px;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 10px 12px 10px 17px;
  border-radius: 16px;
  background: var(--ff-red);
  text-align: left;
}

.integrazione-section .integrazione-button--vitastrong:hover {
  background: #ed123f;
}

.integrazione-button--vitastrong > span:first-child {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.integrazione-button--vitastrong small {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.integrazione-button--vitastrong strong {
  overflow: hidden;
  color: var(--ff-white);
  font-size: 0.85rem;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrazione-button--vitastrong > .material-icons {
  display: grid;
  width: 36px;
  height: 36px;
  flex: 0 0 auto;
  place-items: center;
  color: var(--ff-black);
  border-radius: 12px;
  background: var(--ff-white);
  font-size: 1.1rem;
}

.integrazione-section .integrazione-button--legacy {
  color: var(--ff-black);
  background: #e6d89f;
}

.integrazione-section .integrazione-shop-note,
.integrazione-section .integrazione-disclaimer {
  display: flex;
  gap: 9px;
  align-items: flex-start;
  margin: 15px 0 0;
  color: var(--ff-muted);
  font-size: 0.72rem;
  line-height: 1.45;
}

.integrazione-shop-note .material-icons,
.integrazione-disclaimer .material-icons {
  flex: 0 0 auto;
  color: var(--ff-red);
  font-size: 1rem;
}

.integrazione-shop-note p,
.integrazione-disclaimer p {
  margin: 0 !important;
  color: inherit !important;
  font-size: inherit !important;
  line-height: inherit !important;
}

.integrazione-section .integrazione-disclaimer {
  padding-top: 15px;
  border-top: 1px solid var(--ff-line);
}

.nutrition-support {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 24px;
  align-items: center;
  margin-top: clamp(30px, 6vw, 54px);
  padding: clamp(22px, 4vw, 32px);
  color: var(--ff-white);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 24px;
  background:
    radial-gradient(circle at 92% 10%, rgba(213, 11, 53, 0.46), transparent 12rem),
    var(--ff-black);
  box-shadow: 0 22px 55px rgba(17, 17, 16, 0.18);
}

.nutrition-support__copy {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.nutrition-support__copy > .material-icons {
  display: grid;
  width: 50px;
  height: 50px;
  flex: 0 0 auto;
  place-items: center;
  color: var(--ff-white);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
}

.nutrition-support small {
  display: block;
  margin-bottom: 5px;
  color: rgba(255, 255, 255, 0.58);
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.nutrition-support h2 {
  margin: 0;
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(1.1rem, 3vw, 1.45rem);
  font-weight: 900;
  line-height: 1.08;
}

.nutrition-support p {
  margin: 8px 0 0;
  color: rgba(255, 255, 255, 0.66);
  font-size: 0.88rem;
  line-height: 1.45;
}

.ticket-button {
  display: inline-flex;
  gap: 9px;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 0 18px;
  color: var(--ff-white);
  border-radius: 999px;
  background: var(--ff-red);
  font-size: 0.8rem;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  transition: transform 180ms ease, background 180ms ease;
}

.ticket-button .material-icons {
  font-size: 1.1rem;
}

.ticket-button:hover {
  color: var(--ff-white);
  background: var(--ff-red-dark);
  transform: translateY(-2px);
}

@media (max-width: 620px) {
  .nutrition-shell {
    min-height: calc(100vh - 50px);
    padding: 28px 12px 138px;
  }

  .nutrition-card {
    border-radius: 18px;
  }

  .nutrition-card__trigger {
    grid-template-columns: 46px minmax(0, 1fr) 36px;
    gap: 12px;
    min-height: 82px;
    padding: 12px 13px;
  }

  .nutrition-card__number {
    width: 46px;
    height: 46px;
    border-radius: 14px;
  }

  .nutrition-card__chevron {
    width: 36px;
    height: 36px;
  }

  .nutrition-card__copy strong {
    font-size: 0.98rem;
  }

  .order-details {
    padding: 0 15px 19px;
  }

  .grid-container23 {
    padding-top: 18px;
  }

  .order-details button {
    width: 100%;
  }

  .integrazione-section {
    padding: 18px;
    border-radius: 20px;
  }

  .integrazione-heading {
    text-align: center;
  }

  .integrazione-heading h2 {
    font-size: 1.25rem;
  }

  .integrazione-heading p {
    font-size: 0.8rem;
  }

  .integrazione-partner-row {
    align-items: flex-start;
    margin-top: 20px;
  }

  .integrazione-selection-status {
    max-width: 45%;
    justify-content: flex-end;
    text-align: right;
  }

  .integrazione-bundle-card {
    min-height: 0;
    padding: 17px;
    border-radius: 18px;
  }

  .integrazione-bundle-content {
    grid-template-columns: 1fr;
    gap: 17px;
  }

  .integrazione-price {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .integrazione-price span {
    margin: 0;
  }

  .pdf-viewer {
    min-height: 390px;
    height: 390px;
  }

  .nutrition-support {
    grid-template-columns: 1fr;
    gap: 18px;
    margin-top: 28px;
    padding: 21px;
    border-radius: 20px;
  }

  .nutrition-support__copy > .material-icons {
    width: 44px;
    height: 44px;
  }

  .ticket-button {
    width: 100%;
    box-sizing: border-box;
  }
}

@media (prefers-reduced-motion: reduce) {
  .nutrition-card,
  .nutrition-card::before,
  .nutrition-card__chevron,
  .ticket-button,
  .order-details {
    animation: none;
    transition: none;
  }
}
</style>
